import { compose, withProps } from 'recompose'
import { InputText } from './index'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

export const formatTIN = value => {
  // If nothing provided, return empty string
  if (!value) return ''

  // Formatting - remove all non-digits
  const clean = (value.match(/\d/g) || []).join('')

  // Limit to 9 digits
  return clean.slice(0, 9)
}

const enhance = compose(
  withProps({
    format: formatTIN,
    // Ensure the input has the proper type
    type: 'text',
  }),
  toReduxFormField('InputTIN'),
)

export default enhance(InputText)
